import request from '@/utils/request'
import qs from 'qs';
export function verfiyHas(data) {
    return request({
        url: `/Service/ServiceBroker.ashx`,
        method: 'post',
        showErrorMsg: false,
        data: qs.stringify(data)
    })
}
export function commonAPI(data) {
    return request({
        url: `/Service/ServiceBroker.ashx`,
        method: 'post',
        showErrorMsg: false,
        data: qs.stringify(data)
    })
}
export function subData(data){
    return request({
        url: `/IndividualRegistration.aspx`,
        method: 'POST',
        data: qs.stringify(data)
    })
}
export function getData(data){
    return request({
        url: `/UpdateRegistration.aspx`,
        method: 'POST',
        data: qs.stringify(data)
    })
}
// 上床图片
export const uploadUrl =  '/api/UploadPic.ashx'
